import { createContext, useEffect, useMemo } from "react";
import posthog from "posthog-js";

import { WebTracker } from "../WebTracker";

import type { WebTrackerOptions } from "../types";

const WebTrackerContext = createContext<WebTracker | undefined>(undefined);

interface WebTrackerProviderProps extends WebTrackerOptions {
  children: React.ReactNode;
}

const WebTrackerProvider: React.FC<WebTrackerProviderProps> = ({
  children,
  ...options
}) => {
  const webTracker = useMemo(() => new WebTracker(posthog, options), [options]);

  useEffect(() => {
    webTracker.createElementViewTracker();
    webTracker.createPageViewTracker();
    webTracker.createPageLeaveTracker();

    return () => {
      webTracker.destroyElementViewTracker();
      webTracker.destroyPageViewTracker();
      webTracker.destroyPageLeaveTracker();
    };
  }, [webTracker]);

  return (
    <WebTrackerContext.Provider value={webTracker}>
      {children}
    </WebTrackerContext.Provider>
  );
};

export { WebTrackerProvider, WebTrackerContext };
